import React from "react";
import { Outlet } from "react-router-dom";
import AuthProvider from "../components/user/AuthProvider";
import DesktopProvider from "../components/DesktopProvider";
import SubscriptionsProvider from "../components/subscriptions/SubscriptionsProvider";

export default function SubscriptionsLayout() {
  return (
    <AuthProvider fetchBillings>
      <DesktopProvider>
        <SubscriptionsProvider>
          <Outlet />
        </SubscriptionsProvider>
      </DesktopProvider>
    </AuthProvider>
  );
}
